(() => {
  const STORAGE_KEY = 'eigen-foto:recently-visited';
  const MAX = 5;

  const read = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  };

  const write = (list) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* noop */
    }
  };

  const upsert = (entry) => {
    if (!entry || !entry.handle) return [];
    const list = read().filter((p) => p.handle !== entry.handle);
    list.unshift(entry);
    const trimmed = list.slice(0, MAX);
    write(trimmed);
    return trimmed;
  };

  const renderInto = (section) => {
    const grid = section.querySelector('[data-recently-visited-grid]');
    const tpl = section.querySelector('[data-recently-visited-template]');
    if (!grid || !tpl) return;

    const currentHandle = section.dataset.currentHandle || '';
    const items = read().filter((p) => p.handle !== currentHandle);
    if (!items.length) return;

    grid.innerHTML = '';
    items.forEach((item) => {
      const node = tpl.content.cloneNode(true);
      const link = node.querySelector('[data-rv-link]');
      const image = node.querySelector('[data-rv-image]');
      const title = node.querySelector('[data-rv-title]');
      const price = node.querySelector('[data-rv-price]');
      if (link) link.href = item.url;
      if (image) {
        image.src = item.image;
        image.alt = item.title;
      }
      if (title) title.textContent = item.title;
      if (price) price.textContent = item.price;
      grid.appendChild(node);
    });
    section.hidden = false;
  };

  document.querySelectorAll('[data-recently-visited]').forEach((section) => {
    const currentScript = section.querySelector('[data-recently-visited-current]');
    if (currentScript) {
      try {
        const current = JSON.parse(currentScript.textContent);
        upsert(current);
      } catch (e) {
        /* noop */
      }
    }
    renderInto(section);
  });
})();
